import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { TableChart, ViewKanban } from "@mui/icons-material";
import { useState } from "react";
import Loader from "../../components/common/Loader";
import { useGetStudentsQuery } from "../../services/students.service";
import StudentsTable from "../../components/Students/Table";
import KanbanBoard from "../../components/Students/KanbanBoard";
import { useNavigate } from "react-router-dom";
import { useGetUsersQuery } from "../../services/users.service";

type View = "table" | "kanban";

function StudentsPage() {
  const navigator = useNavigate();
  const [view, setView] = useState<View>("table");

  const { data, error, isLoading } = useGetStudentsQuery("Students");
  const { data: users, error: usersError, isLoading: isLoadingUsers } = useGetUsersQuery("Users");

  const isLoadingData = isLoading || isLoadingUsers;

  if (usersError || error) {
    navigator("/");
  }

  return (
    <Box height="100%" width="100%" display="flex" flexDirection="column" gap={1.5}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", flexShrink: 0 }}>
        <ToggleButtonGroup
          size="small"
          value={view}
          exclusive
          onChange={(_, val) => val && setView(val)}
          sx={{ height: 36 }}
        >
          <ToggleButton value="table" sx={{ px: 1.5, gap: 0.5, fontSize: "0.75rem", fontWeight: 600, textTransform: "none" }}>
            <TableChart fontSize="small" />
            Table
          </ToggleButton>
          <ToggleButton value="kanban" sx={{ px: 1.5, gap: 0.5, fontSize: "0.75rem", fontWeight: 600, textTransform: "none" }}>
            <ViewKanban fontSize="small" />
            Kanban
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      <Box flex={1} minHeight={0}>
        {isLoadingData ? (
          <Loader />
        ) : view === "table" ? (
          <StudentsTable users={users!} rows={data!} />
        ) : (
          <KanbanBoard students={data!} users={users!} />
        )}
      </Box>
    </Box>
  );
}

export default StudentsPage;
